export default {"src":"/_next/static/media/WalletExtensionDark.04957e34.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};